import React from 'react';
import { useTranslation } from 'react-i18next';

import { SkyMapAxiosServiceFactory } from '../../../../../services/axios/skymap-axios-service-factory';
import { isDefined } from '../../../../../utils/variables';
import { AssetManager } from '../../../../../viewer/asset-manager';
import { ElementObj } from '../../../../../viewer/elements/element-obj';
import { AssetFactory } from '../../../../../viewer/loader/asset/asset-factory';
import { Point2d } from '../../../../../viewer/utilities/math-helpers';
import { InputDialog } from '../../../input-dialog/input-dialog';
import { CategoryContext } from '../../state/category-state';

type Props = {
  asset: ElementObj;
  pos?: Point2d;
  onClose: () => void;
};

const DuplicateAssetDialog = (props: Props) => {
  const { t } = useTranslation();
  const { refreshAssets } = React.useContext(CategoryContext);

  return (
    <InputDialog
      initialValue={t('common.duplicateAssetDialog.newName', {
        ns: 'skyviewAssetMenu',
        originalAssetName: props.asset.name,
      })}
      position={props.pos}
      title={t('common.duplicateAssetDialog.title', { ns: 'skyviewAssetMenu' })}
      onCancel={async () => {
        props.onClose();
        return Promise.resolve();
      }}
      onConfirm={async (newValue) => {
        const response = await SkyMapAxiosServiceFactory.instance
          .createAssetServiceV1()
          .duplicateAsset({
            body: {
              name: newValue,
            },
            path: {
              dynamicAssetId: props.asset.assetId!,
            },
          });

        const asset = AssetFactory.instance.buildAsset(response.data, undefined);

        if (isDefined(asset)) {
          AssetManager.instance.addAsset(asset);
        }

        refreshAssets();
        props.onClose();
      }}
    />
  );
};

export { DuplicateAssetDialog, Props as DuplicateAssetDialogProps };
